const cookies = {
  BLOCK_ADS: 'blockAds',
  CLOSED_UNSUB_ALERT: 'closed_unsub_alert',
};

export default cookies;
